export default "/images/classmate-logo.svg?82bde762f64df13ab9f3875ad34a967d";